<template>
    <div>
        <div class="columns">
            <div class="column is-12">
                <h1 class="title is-2">Filters:</h1>
            </div>
        </div>

        <div class="columns">
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Created Account From:</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <datepicker v-model="search.start_date" placeholder="" :config="{ enableTime: false, dateFormat: 'Y-m-d' }"></datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Created Account To:</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <datepicker v-model="search.end_date" placeholder="" :config="{ enableTime: false, dateFormat: 'Y-m-d' }"></datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Last Login From:</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <datepicker v-model="search.ll_from" placeholder="" :config="{ enableTime: false, dateFormat: 'Y-m-d' }"></datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Last Login To:</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <datepicker v-model="search.ll_to" placeholder="" :config="{ enableTime: false, dateFormat: 'Y-m-d' }"></datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Next Billing Date From:</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <datepicker v-model="search.nbt_from" placeholder="" :config="{ enableTime: false, dateFormat: 'Y-m-d' }"></datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Next Billing Date To:</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <datepicker v-model="search.nbt_to" placeholder="" :config="{ enableTime: false, dateFormat: 'Y-m-d' }"></datepicker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Extended trial:</span>
                    <div class="select is-fullwidth">
                        <select  v-model="search.extended">
                            <option value="">Both</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                </div>
            </div>
<!--            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Paid:</span>
                    <div class="select is-fullwidth">
                        <select  v-model="search.paid">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                </div>
            </div>-->
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Logged In Min Times:</span>
                    <div class="is-fullwidth">
                        <input class="input" type="number" v-model="search.logged_in">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Subscription status:</span>
                    <div class="select is-fullwidth">
                        <select  v-model="search.sub_status">
                            <option value="">Any</option>
                            <option v-for="item in subscription_status" v-bind:value="item.id">{{item.text}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">Subscription plan:</span>
                    <div class="select is-fullwidth">
                        <select  v-model="search.sub_plan">
                            <option value="">Both(with and without)</option>
                            <option v-for="item in subscription_plans" v-bind:value="item.id">{{item.text}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span class="label has-text-grey-dark">School:</span>
                    <div class="select is-info is-fullwidth">
                        <select v-model="search.schools">
                            <option value="">Any</option>
                            <option v-for="school in schools" v-bind:value="school.id">{{school.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <span  style="color: transparent !important;" class="label has-text-grey-dark">Search</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <loading-button v-bind:loading="loading" color="is-info" @click="clearSearch()">Clear Search</loading-button>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <div class="columns">
            <div class="column is-6">
                <div class="field">
                    <span  style="color: transparent !important;" class="label has-text-grey-dark">Search</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <loading-button v-bind:loading="loading" color="is-info" @click="filter(false)">Search</loading-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="column is-6">
                <div class="field">
                    <span  style="color: transparent !important;" class="label has-text-grey-dark">Export</span>
                    <div class="control">
                        <div class="is-info is-fullwidth">
                            <loading-button v-bind:loading="loading" color="is-primary" @click="filter(true)">Export</loading-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <table class="table is-hoverable is-bordered is-fullwidth">
            <thead>
                <tr>
                    <th v-for='col in columns' class="sortable" @click='sortBy(col.key)'>
                        {{col.name}} 
                        <i class="fa fa-sort-up is-pulled-right" v-if="column == col.key && reverse"></i>
                        <i class="fa fa-sort-down  is-pulled-right" v-if="column == col.key && !reverse"></i>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items" @click="show(item.id)">
                    <td>{{item.id}}</td>
                    <th>{{item.email}}</th>		  
                    <td>{{item.profile && item.profile.name}}</td>
                    <td>{{item.subscription && item.subscription.next_bill_date}}</td>
                    <td>{{item.subscription && item.subscription.plan}}</td>
                    <td>{{item.last_login}}</td>
                    <td>{{item.created_at.date}}</td>
                </tr>
            </tbody>
        </table>
        <bulma-pagination :current="page" @change="onPageChanged" :last="total"></bulma-pagination>
    </div>
</template>

<script>
import UserRepo from '../../repos/UserRepo'
import lodash from 'lodash'
import Datepicker from 'vue-bulma-datepicker';

export default {
  name: 'users-table',
  props: {
	    items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: {required: false, default: false}
  },
  components: {Datepicker},
  data() {
        return {
            //search: '',
            schools: [],
            column: 'users.id',
            search:{
                start_date: null,
                end_date: null,
                ll_from: null,
                ll_to: null,
                nbt_from: null,
                nbt_to: null,
                extended: "",
                paid: "",
                logged_in: null,
                schools: "",
                sub_status: null,
                sub_plan: "",
                export: false
            },
            loading:false,
            columns: [
                {
                    name: '#',
                    key: 'users.id'
                },
                {
                    name: 'Email',
                    key: 'users.email'
                },
                {
                    name: 'Name',
                    key: ''
                },
                {
                    name: 'Next bill date',
                    key: ''
                    //key: 'subscriptions.next_bill_date'
                },
                {
                    name: 'Subscription',
                    key: ''
                    //key: 'subscriptions.subscription_plan_id'
                },
                {
                    name: 'Last login',
                    key: 'users.last_login'
                },
                {
                    name: 'Registred at',
                    key: 'users.created_at'
                },

            ],
            reverse: true,
            repo: new UserRepo(this.$auth),            
        }
  },
  created(){
      this.loadSchools();
      this.filter();
  },
  methods: {

        clearSearch(){
            this.search = {
                    start_date: null,
                    end_date: null,
                    ll_from: null,
                    ll_to: null,
                    nbt_from: null,
                    nbt_to: null,
                    extended: "",
                    paid:"",
                    logged_in: null,
                    schools: "",
                    sub_status: null,
                    sub_plan: "",
                    export: false
            };
            this.filter();
        },
        sortBy(column) {
            if(column != ''){
                if(this.column == column){
                  this.reverse = !this.reverse;
                }
                else{
                  this.column = column;
                }

                let direction = this.reverse ? "asc" : "desc";

                //this.$emit("sort", this.column + "," + direction);

                let search =  Object.assign(this.search, {'sort':this.column, 'direction':direction});
                this.search.export = false;
                this.$emit("sort", search);
            }
        },
        onPageChanged(page){
            let search =  Object.assign(this.search, {'page':page});
            this.search.export = false;
            this.$emit("pageChanged", search);
        },
        filter(exp = false){
            this.search.export = exp;
            this.$emit("search", this.search);
        },
        loadSchools(){
          this.loading = true;
          this.schoolRepo.all().then(response => {
              this.schools = response.data.data;
              this.loading = false;

          }).catch((response) =>{
              this.loading = false;
              return Promise.reject(response);
          });
        },
  },
  watch: {
/*      'search': _.debounce(function(value){
        this.$emit("search", value);
      }, 800) */
  },
  computed: {
  }  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/user-export/Table.vue